import { Checkbox, Divider, FormControlLabel, Snackbar, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/styles";
import ReactQuill, { Quill } from "react-quill";
import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ImageResize from "quill-image-resize-module-react";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";

import Dialog from "../dialog/functional/Dialog";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import DialogContent from "../dialog/functional/DialogContent";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";

import "react-quill/dist/quill.snow.css";

Quill.register("modules/imageResize", ImageResize);

const useStyles = makeStyles((theme) => ({
    keepOpenSwitch: {
        marginLeft: "8px",
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text,
    },
}));

function TkPopNoticeWrite(props) {
    const classes = useStyles();

    const { id, open, moveable, resizable, fullWidth, title, schema, onClose, onSuccess, ...others } = props;

    const [visible, setVisible] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [instance, setInstance] = useState();

    const [title_, setTitle] = useState();
    const [, setNotice] = useState();

    const [, setHeader] = useState();

    const [height, setHeight] = useState();

    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    const params = useParams();

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const okRef = useRef(null);

    const { t } = useTranslation();

    const onCloseDialog = () => {
        window.close();
        if (onClose) {
            onClose();
        }
    };

    const onDialogInitialized = (instance) => {
        setInstance(instance);
    };

    const onApiSuccess = (result) => {
        instance.hide();

        if (onSuccess) {
            setTimeout(onSuccess(result.data), 0);
        }

        setTitle(undefined);
        setNotice(undefined);
        window.opener.postMessage({ message: "Success", t: result.data }, "*");
        window.close();
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onApiFailure = (reason) => {
        window.opener.postMessage(
            {
                message: "Failure",
                t: t("error.insertFailure", {
                    reason: reason.response ? reason.response.data : JSON.stringify(reason),
                }),
            },
            "*"
        );

        notifyFailure(
            t("error.insertFailure", {
                reason: reason.response ? reason.response.data : JSON.stringify(reason),
            })
        );
    };

    const onOk = () => {
        okRef.current.blur();

        setNotice((notice) => {
            const url = `/api/TkPopNotice/${params.workOrderNumber}/${params.partNo}`;

            apiClient
                .post(url, { title: title_, notice, visible: visible })
                .then(onApiSuccess)
                .catch((reason) => onApiFailure(reason));
        });
    };

    const onCloseNotification = () => {
        setNotification((notification) => {
            return { ...notification, open: false };
        });
    };

    const onCancel = () => {
        instance.hide();
        window.close();
    };

    function getTitle(event) {
        setTitle(event.target.value);
    }

    function getNotice(previousRange, source, editor) {
        setNotice(editor.getHTML());
    }

    const checkVisible = () => {
        return (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={visible}
                            color="primary"
                            onChange={() => setVisible((visible) => !visible)}
                            name="checkVisible"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.todayNotice")}</span>}
                />
                <div style={{ flexGrow: 1 }}></div>
            </>
        );
    };

    function preserveSizeFormat(node, delta) {
        const match = node.className.match(/ql-size-(.*)/);
        const fontSize = node.style["font-size"];
        let regex = /\d+[.][\d]|\d+/; // 크기
        let regex1 = /[^\s\d.-]+/g; // 단위

        const ratio = fontSize.match(regex);
        const point = fontSize.match(regex1);
        if (match || fontSize) {
            delta.map(function (op) {
                if (!op.attributes) op.attributes = {};
                // grab the size from `ql-size-{x}`
                if (match) {
                    op.attributes.size = match[1];
                } else if (fontSize) {
                    let size;

                    if (point[0].toLowerCase() === "px" || point[0].toLowerCase() === "pt") {
                        if (parseFloat(ratio) <= 10) {
                            size = "small";
                        } else if (parseFloat(ratio) <= 13) {
                            size = false;
                        } else if (parseFloat(ratio) <= 18) {
                            size = "large";
                        } else {
                            size = "huge";
                        }
                    } else {
                        if (parseFloat(ratio) <= 0.75) {
                            size = "small";
                        } else if (parseFloat(ratio) <= 0.8125) {
                            size = false;
                        } else if (parseFloat(ratio) <= 1.5) {
                            size = "large";
                        } else {
                            size = "huge";
                        }
                    }
                    op.attributes.size = size;
                }
                return op;
            });
        }

        return delta;
    }

    const imageHandler = () => {
        console.log("에디터에서 이미지 버튼을 클릭하면 이 핸들러가 시작됩니다!");

        // 1. 이미지를 저장할 input type=file DOM을 만든다.
        const input = document.createElement("input");
        // 속성 써주기
        input.setAttribute("type", "file");
        input.setAttribute("accept", "image/*");
        input.click(); // 에디터 이미지버튼을 클릭하면 이 input이 클릭된다.
        // input이 클릭되면 파일 선택창이 나타난다.

        // input에 변화가 생긴다면 = 이미지를 선택
        input.addEventListener("change", async () => {
            const file = input.files[0];
            // multer에 맞는 형식으로 데이터 만들어준다.
            let formData = new FormData();

            formData.append("image", file); // formData는 키-밸류 구조
            // 백엔드 multer라우터에 이미지를 보낸다.
            try {
                const result = await apiClient.post("/api/TkPopNotice", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                const FILE_PATH = "/files/" + result?.data[0]?.path;
                const REAL_PATH =
                    process.env.NODE_ENV === "production" ? FILE_PATH : "http://localhost:8080" + FILE_PATH;

                const editor = okRef.current.getEditor(); // 에디터 객체 가져오기

                // 1. 에디터 root의 innerHTML을 수정해주기
                // editor의 root는 에디터 컨텐츠들이 담겨있다. 거기에 img태그를 추가해준다.
                // 이미지를 업로드하면 -> 멀터에서 이미지 경로 URL을 받아와 -> 이미지 요소로 만들어 에디터 안에 넣어준다.
                // editor.root.innerHTML =
                //   editor.root.innerHTML + `<img src=${IMG_URL} /><br/>`; // 현재 있는 내용들 뒤에 써줘야한다.

                // 2. 현재 에디터 커서 위치값을 가져온다
                const range = editor.getSelection();
                // 가져온 위치에 이미지를 삽입한다
                editor.insertEmbed(range.index, "image", REAL_PATH);
                editor.setSelection(range.index + 1);
            } catch (error) {
                console.log("실패했어요ㅠ");
            }
        });
    };

    const modules = useMemo(() => {
        return {
            clipboard: {
                matchers: [
                    [
                        Node.ELEMENT_NODE,
                        function (node, delta) {
                            let lastHeader =
                                delta?.ops[0]?.attributes?.header ||
                                okRef?.current?.lastDeltaChangeSet?.ops[
                                    okRef?.current?.lastDeltaChangeSet?.ops.length - 1
                                ]?.attributes?.header;

                            setHeader((pre) => {
                                lastHeader = lastHeader || pre;
                                return lastHeader;
                            });

                            delta.map(function (op) {
                                if (!op.attributes) op.attributes = {};
                                op.attributes.header = lastHeader;
                                return op;
                            });
                            return delta;
                            // return delta.compose(new Delta().retain(delta.length(), // 거의 동일하게 복사 붙여넣기 위한 코드
                            //     {
                            //         // header: lastHeader,
                            //     }
                            // ));
                        },
                    ],
                    ["span", preserveSizeFormat],
                ],
            },
            keyboard: {
                bindings: {
                    "header enter": {
                        key: "Enter",
                        format: ["header", "size", "color"],
                        handler(range, context) {
                            // enter 입력시 (줄바뀜) 폰트 사이즈, 헤더 설정 유지를 위한 코드
                            return true;
                        },
                    },
                },
            },
            toolbar: {
                container: [
                    //["image"],
                    [{ size: [] }],
                    [{ font: [] }],
                    [{ header: [] }],
                    ["bold", "italic", "underline", "strike", "blockquote"],
                    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],

                    [{ align: [] }, { color: [] }, { background: [] }], // dropdown with defaults from theme
                    ["clean"],
                ],
                handlers: {
                    // 이미지 처리는 우리가 직접 imageHandler라는 함수로 처리할 것이다.
                    image: imageHandler,
                },
            },
            imageResize: {
                parchment: Quill.import("parchment"),
                modules: ["Resize", "DisplaySize", "Toolbar"],
            },
        };
    }, [okRef]);

    let formats = [
        "image",
        "size",
        "font",
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "align",
        "color",
        "background",
    ];

    const click = (e) => {
        if (e.target.className === "ql-picker-item ql-selected") {
            setHeader(e?.target?.dataset?.value);
        }
    };

    return (
        <div>
            <Dialog
                id={id}
                // moveable={moveable ? moveable : uiConf.dialogMoveable}
                resizable={resizable ? resizable : uiConf.dialogResizable}
                fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
                // maxWidth="lg"
                fullScreen={true}
                onClose={onCloseDialog}
                onInitialized={onDialogInitialized}
                open={true}
                {...others}
            >
                <DialogHeaderWithClose></DialogHeaderWithClose>

                <DialogContent orientation="vertical" style={{ height: height }}>
                    <TextField
                        fullWidth
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="제목을 입력하세요"
                        margin="dense"
                        onBlur={(value) => getTitle(value)}
                    />
                    <div onClick={click}>
                        <ReactQuill
                            ref={okRef}
                            style={{ height: height - 150, fontSize: "16px" }}
                            placeholder="공정 전달 사항을 작성해 주세요."
                            modules={modules}
                            formats={formats}
                            onChange={(a, b, c, editor) => {
                                if (editor.getHTML().length > 7 && disabled === true) {
                                    setDisabled(false);
                                }

                                if (editor.getHTML() === "<p><br></p>" && disabled === false) {
                                    setDisabled(true);
                                }
                            }}
                            onBlur={(previousRange, source, editor) => getNotice(previousRange, source, editor)}
                        />
                    </div>

                    <Snackbar
                        open={notification.open && notification.severity !== "success"}
                        autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                        onClose={onCloseNotification}
                    >
                        <Alert onClose={onCloseNotification} variant="filled" severity={notification.severity}>
                            {notification.msg}
                        </Alert>
                    </Snackbar>
                </DialogContent>

                <Divider />

                <DialogActionsOkCancel
                    //firstActionComponent={checkVisible}
                    labels={[t("common.add")]}
                    buttonDisabled={[disabled, false]}
                    onOk={() => onOk()}
                    onCancel={onCancel}
                ></DialogActionsOkCancel>
            </Dialog>
        </div>
    );
}

export default TkPopNoticeWrite;
